<template>
  <div>
    <m-documents-show-files :active="isShowFilesModal" :files="record.files.items" @close="isShowFilesModal = false" />
    <div class="documents-files-cell" @click="isShowFilesModal = true">
      {{ cellValue }}
    </div>
  </div>
</template>

<script>
import DocumentsShowFilesModal from "@/pages/personal-employee/additions/modals/documents-show-files-modal";

export default {
  name: "documents-files-cell",
  components: {
    "m-documents-show-files": DocumentsShowFilesModal,
  },
  props: ["record", "cellValue"],
  data() {
    return {
      isShowFilesModal: false,
    };
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.documents-files-cell {
  cursor: pointer;
  line-height: 13px;
  font-size: 13px;
  padding: 10px !important;
  color: #0066ff;
  line-height: 100%;
  -webkit-transition: font 0.3s ease;
  text-align: left;
  transition: font 0.3s ease;
}
</style>
